import { createRouter, createWebHistory } from "vue-router";
import { routes, listingBreadCrumbs } from "@/pages";
import { todayISODate } from "@/helpers/format";
import { i18n } from "@/i18n.ts";

export const newRouter = () => {
  const history = createWebHistory();
  const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    if (to.path != from.path) return { top: 0 };
  };
  const router = createRouter({ routes, history, scrollBehavior, strict: true });
  router.beforeEach(async (to) => {
    const eventStore = useEventStore();
    eventStore.resetVatFilter();

    const shouldBuildListingBreadcrumbs = to.matched?.some((r) => r.meta?.dynamicListingBreadcrumbs) ?? false;

    let dateStartChanged = false;
    if (to.query.date_start === "today") {
      to.query.date_start = todayISODate;
      dateStartChanged = true;
    }

    if (shouldBuildListingBreadcrumbs) {
      to.meta.path = await listingBreadCrumbs(to);
    }

    // Return the updated `to` only when we changed query params
    if (dateStartChanged) return to;
  });
  router.afterEach((to) => {
    const language = to.params?.language;
    if (language in LOCALES) {
      i18n.global.locale.value = language;
      localStorage.AcceptLanguage = language;
    }
  });

  return router;
};

import { LOCALES } from "@/components/page/menu/locales.js";
import { useEventStore } from "@/store/event.js";
